import { Component, OnInit, SecurityContext } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'neoris-minidashboard-user-dz',
  templateUrl: './minidashboard-user-dz.component.html',
  styleUrls: ['./minidashboard-user-dz.component.css']
})
export class MinidashboardUserDzComponent  {

  siteId:string;
  isProductionCloud:boolean;
  iframeSrc: SafeResourceUrl;
  access_token: string;
  siteId_slp:string = '2000';

  constructor(private sanitizer: DomSanitizer,private cookieService: CookieService) {
    this.isProductionCloud = environment.isProductionCloud;
    this.access_token = this.cookieService.get('access-token') 
    this.siteId = localStorage.getItem('site')
    let url = "";

    if(this.isProductionCloud && this.siteId === this.siteId_slp){
      url = 'https://minidashboard-user-slp-dz-prod.azurewebsites.net/?token=' + this.access_token;
    }

    if(this.isProductionCloud === false && this.siteId === this.siteId_slp){
        url = 'https://minidashboard-user-slp-dz-qa.azurewebsites.net/?token=' + this.access_token;
    }

    this.iframeSrc = this.sanitizer.sanitize(SecurityContext.RESOURCE_URL,url);
   }


}